import React, {useEffect, useState} from 'react';
import {Alert, Button, Card, Descriptions, Spin} from 'antd';
import {LogoutOutlined, UserOutlined} from '@ant-design/icons';
import {userService} from '../../services/userService';
import {useAuth} from '../../contexts/AuthContext';
import {User} from '../../types/user';
import ChangePasswordForm from './components/ChangePasswordForm';

const PersonalInfo: React.FC = () => {
    const {logout} = useAuth();
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        loadUserInfo();
    }, []);

    const loadUserInfo = async () => {
        try {
            setLoading(true);
            setError(null);
            const userData = await userService.getCurrentUser();
            setUser(userData);
        } catch (err: any) {
            // console.error('加载用户信息失败', err);
            setError(err.message || '加载用户信息失败');
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = () => {
        logout();
        window.location.href = '/login';
    };

    if (loading) {
        return (
            <div style={{textAlign: 'center', marginTop: 100}}>
                <Spin size="large"/>
                <div style={{marginTop: 16}}>加载中...</div>
            </div>
        );
    }

    if (error) {
        return (
            <Alert
                message="加载失败"
                description={error}
                type="error"
                showIcon
                style={{marginBottom: 16}}
                action={
                    <Button size="small" onClick={loadUserInfo}>
                        重试
                    </Button>
                }
            />
        );
    }

    return (
        <div style={{maxWidth: 800}}>
            <Card
                title={
                    <span>
                        <UserOutlined style={{marginRight: 8}}/>
                        个人信息
                    </span>
                }
                extra={
                    <Button danger icon={<LogoutOutlined/>} onClick={handleLogout}>
                        退出登录
                    </Button>
                }
                style={{marginBottom: 24}}
            >
                <Descriptions column={1} bordered>
                    <Descriptions.Item label="用户ID">{user?.userId}</Descriptions.Item>
                    <Descriptions.Item label="用户名">{user?.username}</Descriptions.Item>
                    <Descriptions.Item label="邮箱">{user?.email || '-'}</Descriptions.Item>
                    <Descriptions.Item label="状态">{user?.status}</Descriptions.Item>
                    <Descriptions.Item label="角色">
                        {user?.roles?.join(', ') || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="创建时间">
                        {user?.createdTime || '-'}
                    </Descriptions.Item>
                </Descriptions>
            </Card>

            <ChangePasswordForm/>
        </div>
    );
};

export default PersonalInfo;
